import React from 'react';

export default function TelegramInvitation() {
    return (
        <div className="telegram-invitation">
            <div className="telegram-invitation__icon">
                <img
                    src="/images/icon/social-media/telegram.webp"
                    alt="Telegram"
                />
            </div>

            <div className="telegram-invitation__content">
                <span className="telegram-invitation__title">
                    Join Our Telegram Community!
                </span>

                <p className="telegram-invitation__description">
                    Get exclusive activities, game updates, and special
                    announcements.
                </p>

                <a
                    className="telegram-invitation__button"
                    href="https://t.me/fghofficialactivitygroup"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Join Now
                    <span aria-hidden="true">↗</span>
                </a>
            </div>
        </div>
    );
}
